import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAcrLogo = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 54,
	height: 54,
	viewBox: "0 0 54 54",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M22.3021 22.4974L30.0734 17.7758L51.8502 25.9733C51.3747 23.8578 50.2844 21.93 48.7165 20.4323L48.6865 20.2822C46.8562 18.5138 44.5328 17.3416 42.0229 16.9204C41.859 13.0212 40.1553 9.34621 37.2855 6.70149C34.4157 4.05676 30.6141 2.65825 26.7145 2.81271C23.5693 2.7558 20.4838 3.67475 17.8822 5.44316C15.2807 7.21158 13.2909 9.74259 12.1866 12.6881C8.87873 13.0917 5.82673 14.6728 3.58893 17.1421C1.35114 19.6114 0.0771426 22.8038 0 26.1354C0.148517 29.8857 1.776 33.4246 4.52656 35.9783C7.27713 38.532 10.927 39.8927 14.678 39.7628H22.3021V22.4974Z",
			fill: "url(#paint0_linear_117153_268)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M30.2261 19.4385L30.2561 32.2855L53.999 37.3282V28.3833L30.2261 19.4385Z",
			fill: "#767676"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M30.2272 19.4385L23.8037 23.3406V35.2871L30.2572 32.2855",
			fill: "#999999"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M41.0632 32.4654L43.2244 33.0657V26.0719L41.0632 25.3215V32.4654Z",
			fill: "#A3A3A3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M38.9019 24.6313L36.7407 23.8508V31.3249L38.9019 31.9252V24.6313Z",
			fill: "#A3A3A3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M45.3853 33.636L47.4864 34.2063L47.5464 27.5427L45.3853 26.8223V33.636Z",
			fill: "#A3A3A3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M32.448 30.2143L34.6092 30.7546V23.1605L32.448 22.4401V30.2143Z",
			fill: "#A3A3A3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M51.8377 29.0142L49.6765 28.2638V34.7773L51.8377 35.3777V29.0142Z",
			fill: "#A3A3A3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M25.9939 32.0754L24.9133 32.7058V24.2111L25.9939 23.6408V32.0754ZM28.1251 22.4102L27.0145 23.1305V31.385L28.1251 30.7847V22.4102Z",
			fill: "#B3B3B3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M54.0001 37.3283L47.5166 39.5495L23.8037 35.2872L30.2572 32.2855L54.0001 37.3283Z",
			fill: "url(#paint1_linear_117153_268)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M53.9997 46.4836L30.1367 51.0161L30.2568 34.2369L53.9997 38.6493V46.4836Z",
			fill: "#767676"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M32.448 48.2542V37.5984L34.6092 37.8685V47.894L32.448 48.2542Z",
			fill: "#A3A3A3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M38.9019 47.1735L36.7407 47.5637V38.1385L38.9019 38.4687V47.1735Z",
			fill: "#A3A3A3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M41.0632 46.8439V38.6794L43.2244 38.9496V46.4537L41.0632 46.8439Z",
			fill: "#A3A3A3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M47.5164 45.703L45.3853 46.0932V39.2195L47.5164 39.5497V45.703Z",
			fill: "#A3A3A3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M51.8977 45.0124L49.6765 45.4026V39.7595L51.7476 40.0297L51.8977 45.0124Z",
			fill: "#A3A3A3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23.8037 47.1764V37.391L30.2872 34.3894V51.1985L23.8037 47.1764Z",
			fill: "#999999"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M25.8443 47.1436L24.8838 46.6633V38.3788L25.8443 37.9286V47.1436ZM28.1556 36.788L27.0149 37.3583V47.804L28.1256 48.3743V36.788H28.1556Z",
			fill: "#B3B3B3"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_117153_268",
			x1: 25.9251,
			y1: -8.02619,
			x2: 25.9251,
			y2: 48.1944,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#5EA0EF" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#0078D4"
			})]
		}), /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint1_linear_117153_268",
			x1: 38.9019,
			y1: 32.2855,
			x2: 38.9019,
			y2: 39.5495,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#333132" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#5B5A5C"
			})]
		})] })
	]
});
const ForwardRef = forwardRef(SvgAcrLogo);
export { ForwardRef as ReactComponent };
